"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePopover = void 0;
var react_1 = require("react");
/**
 *  Хук, отвечающий за открытие всплывающего окна
 *  @returns {UsePopover} { anchorEl, setPopoverClose, setPopoverOpen, isOpen }
 *  - anchorEl - корневой элемент, при нажатии на который произошло открытие окна
 *  - setPopoverClose - функция закрытия окна
 *  - setPopoverClose - функция открытия окна
 *  - isOpen - состояние окна (true если открыто, false если закрыто)
 */
var usePopover = function () {
    var _a = (0, react_1.useState)(null), anchorEl = _a[0], setAnchorEl = _a[1];
    var isOpen = (0, react_1.useMemo)(function () { return !!anchorEl; }, [anchorEl]);
    var setPopoverOpen = (0, react_1.useCallback)(function (event) {
        setAnchorEl(event.currentTarget);
    }, [setAnchorEl]);
    var setPopoverClose = (0, react_1.useCallback)(function () {
        setAnchorEl(null);
    }, [setAnchorEl]);
    return { anchorEl: anchorEl, setPopoverClose: setPopoverClose, setPopoverOpen: setPopoverOpen, isOpen: isOpen };
};
exports.usePopover = usePopover;
